// @ts-check
import { ITERATION_TYPE, PM_PROVIDERS } from 'common/constants/constants';
import { SPACES } from 'common/constants/sizes';
import { pluralize } from 'common/utils/utils';
import { Flex, Separator } from 'components/base/layout-components';
import Text from 'components/base/Text';
import _ from 'lodash';
import { FILTER_TYPES } from 'common/constants/filters';
import { LBButton } from '@linearb/buzz';

const Header = ({
  selectedTeamName,
  projectsFormatedForDropdown,
  selectedProviderIds,
  itrationsType,
  selectedIterations,
  isSaveEnabled,
  onSave,
  selectedFilters,
  pmToolConfig
}) => {
  const getAzureBoardsSelectedTitle = () => {
    const selectedTeamNames = (
      selectedFilters[FILTER_TYPES.AZURE_BOARDS_PROJECT_TEAM_AREAS] || []
    )
      .map(projectTeamArea => projectTeamArea?.team?.name)
      .filter(Boolean);
    const uniqueSelectedTeamNames = [...new Set(selectedTeamNames)];
    switch (uniqueSelectedTeamNames.length) {
      case 0:
        return `no filters selected`;
      case 1:
        return uniqueSelectedTeamNames[0];
      default:
        return `${uniqueSelectedTeamNames.length} teams selected`;
    }
  };

  const selectedProjectTitle = selectedIds => {
    if (pmToolConfig.sensor_id === PM_PROVIDERS.AZURE_BOARDS)
      return getAzureBoardsSelectedTitle();

    if (!selectedIds?.length) {
      return `No ${pmToolConfig.entity_name} selected`;
    }
    return selectedIds.length > 1
      ? `${pluralize(selectedIds?.length, pmToolConfig.entity_name)} selected`
      : _.get(
          _.find(
            projectsFormatedForDropdown,
            project => project.value === selectedIds[0]
          ),
          'searchableValue',
          `No ${pmToolConfig.entity_name} selected`
        );
  };

  return (
    <Flex items='center'>
      <Flex direction='column'>
        <Text
          size='large'
          weight='500'
          textTransform='uppercase'
          pb={SPACES.small}
        >
          {selectedTeamName} - {pmToolConfig.name} settings
        </Text>
        <Text size='medium' color='shuttleGray' pb={SPACES.small}>
          Manage {pmToolConfig.name} settings to get a more accurate view of
          your team activity
        </Text>
      </Flex>
      {projectsFormatedForDropdown.length ? (
        <Flex grow='1' items='center' justify='flex-end'>
          <Text size='medium' pr={SPACES.small}>
            {selectedProjectTitle(selectedProviderIds)}
          </Text>
          {itrationsType === ITERATION_TYPE.IMPORT && (
            <>
              <Separator height='1.2rem' margin='0 1rem 0 0'></Separator>
              <Text color='shuttleGray' size='medium' pr={SPACES.small}>
                {pluralize(selectedIterations, 'Iteration')} selected
              </Text>
            </>
          )}
          <LBButton
            size='lg'
            data-cy='SaveSettings'
            data-testid='SaveSettings'
            disabled={!isSaveEnabled}
            onClick={onSave}
          >
            Save Settings
          </LBButton>
        </Flex>
      ) : null}
    </Flex>
  );
};

export default Header;
